/** @file Rotation from yaw, pitch and roll in degrees, in the Pose3D convention (design section 4). */
import type { Quat } from './quat';
import { quatMul } from './quatMul';

const HALF_DEG = Math.PI / 360;

/**
 * Roll about the local forward axis, then pitch about the local x axis, then yaw about world z
 * (`qYaw * qPitch * qRoll`). An unrotated node faces south (-y) with up +z. Yaw is clockwise seen from above
 * (right-handed about -z), so yaw 90 turns south to west (-x). Pitch up is positive (forward gains +z):
 * right-handed about -x. Roll is
 * right-handed about the forward axis (-y), i.e. counter-clockwise as seen from in front of the node.
 */
export function quatFromYawPitchRoll(yawDeg: number, pitchDeg: number, rollDeg: number): Quat {
  const y = yawDeg * HALF_DEG;
  const p = pitchDeg * HALF_DEG;
  const r = rollDeg * HALF_DEG;
  const qYaw: Quat = [0, 0, -Math.sin(y), Math.cos(y)];
  const qPitch: Quat = [-Math.sin(p), 0, 0, Math.cos(p)];
  const qRoll: Quat = [0, -Math.sin(r), 0, Math.cos(r)];
  return quatMul(quatMul(qYaw, qPitch), qRoll);
}
